export const ActionName = {
  SET_ACCOUNT_DATA: 'SET_ACCOUNT_DATA',
  CLEAR_ACCOUNT_DATA: 'CLEAR_ACCOUNT_DATA',
}

export const Action = {
  SetAccountData: account => ({ type: ActionName.SET_ACCOUNT_DATA, payload: account }),
  ClearAccountData: _ => ({ type: ActionName.CLEAR_ACCOUNT_DATA }),
}
